import { TabContentTranslations } from ".";

export const TAB_CONTENT_ES_MX: TabContentTranslations = {
	consolidated: "Competencia",
	extract: "Extracto",
	revenueSettlement: "Liquidación de Caja",
	pendingTransactions: "Transacciones Pendientes",
	new: "NUEVO",
	consolidatedTooltip:
		"Indica el período en que la venta u operación fue realizada, independientemente de la fecha de pago.",
	revenueSettlementTooltip:
		"Indica el período en que los valores fueron efectivamente pagados o recibidos.",
	pendingTransactionsTooltip:
		"List de transacciones en evaluación por el equipo de Zig, aún no registradas en el extracto.",
};
